import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Chart } from 'chart.js';
import { AnalyticsService } from 'src/app/services/analytics.service';
import {firstBy} from 'thenby';

@Component({
  selector: 'app-crew-ratings-chart-view',
  templateUrl: './crew-ratings-chart-view.component.html',
  styleUrls: ['./crew-ratings-chart-view.component.scss']
})
export class CrewRatingsChartViewComponent implements OnInit, OnChanges {
  @Input() crewRatings = [];

  times: any[] = [];
  ratings: any[] = [];
  monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  lineChartData: Chart.ChartDataSets[] = [
    {
      label: 'Safety Ratings',
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,192,192,1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [],
    },
  ];
  lineChartLabels: Array<any> = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'];
  lineChartOptions: any = {
    responsive: true,
    legend: {
      display: true
    },
    scales: {
      yAxes: [{id: 'y-axis-1', type: 'linear', position: 'left', ticks: {min: 0, max: 5},
       scaleLabel: {display: true, labelString: 'Ratings'} }],
      xAxes: [{scaleLabel: {display: true, labelString: 'Date'} }] 
    },
    maintainAspectRatio: false
  };
   lineChartLegend = false;
  lineChartType = 'line';
  inlinePlugin: any;
  textPlugin: any;
  constructor(private readonly analyticService: AnalyticsService) { }

  ngOnInit() {
    // inline plugin
    this.textPlugin = [{
      id: 'textPlugin',
      beforeDraw(chart: any): any {
        const width = chart.chart.width;
        const height = chart.chart.height;
        const ctx = chart.chart.ctx;
        ctx.restore();
        const fontSize = (height / 114).toFixed(2);
        ctx.font = `${fontSize}em sans-serif`;
        ctx.textBaseline = 'middle';
        const text = 'Text Plugin';
        const textX = Math.round((width - ctx.measureText(text).width) / 2);
        const textY = height / 2;
        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    }];

    this.inlinePlugin = this.textPlugin;
  }

  ngOnChanges() {
    this.ratings = [];
    this.times = [];
    if (this.crewRatings && this.crewRatings.length) {
      const s = firstBy('createdAt');
      this.crewRatings.sort(s);
      this.crewRatings.forEach(rating => {
        const date = new Date(rating.createdAt);
        this.times.push(`${date.getDate()} ${this.monthNames[date.getMonth()]}, ${date.getFullYear()}`);
        this.ratings.push(rating.finalRating);
      });
    }
    this.setLineData(this.ratings, this.times);
  }

  setLineData(ratings: number[], labels: string[]) {
    this.lineChartData = [
      {
        label: 'Safety Ratings',
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 5,
        pointHitRadius: 10,
        data:  ratings,
      },
    ];
    this.lineChartLabels = labels;
  }

}
